import classNames from 'classnames';

type IconProps = {
  className?: string;
} & any;

export default function IPIcon({ className, ...props }: IconProps) {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      className={classNames('stroke-current fill-current stroke-0', className)}
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.1005 12L7 16.8995L11.8995 12H11.899C10.6364 13.2372 8.9073 14 7 14C5.09269 14 3.36355 13.2372 2.10102 12H2.1005Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM7 12.5C10.0376 12.5 12.5 10.0376 12.5 7C12.5 3.96243 10.0376 1.5 7 1.5C3.96243 1.5 1.5 3.96243 1.5 7C1.5 10.0376 3.96243 12.5 7 12.5Z"
        fill="currentColor"
      />
      <rect x="5" y="4.5" width="1" height="5" rx="0.5" fill="currentColor" />
      <rect x="7" y="4.5" width="1" height="5" rx="0.5" fill="currentColor" />
      <path
        d="M7.5 5H8.5H8.64645C8.87282 5 9.08993 5.08993 9.25 5.25V5.25C9.41007 5.41007 9.5 5.62718 9.5 5.85355V6V6.14645C9.5 6.37282 9.41007 6.58993 9.25 6.75V6.75C9.08993 6.91007 8.87282 7 8.64645 7H8.5H7.5"
        stroke="currentColor"
      />
    </svg>
  );
}
